export default { release:'25.10-BETA.1' }
